import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import OrderLineItemsComponent from './OrderLineItemsComponent';
import OrderShipmentsContainer from './shipments/OrderShipmentsContainer';
import { ProductConfiguration } from '../../../products/productConfiguration';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

export default class OrderShipmentsAndLineItemsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      order: null,
      activeTab: 'Shipments',
    };
  }
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onShipmentsUpdated: PropTypes.func.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
  };
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    const { order, onShipmentsUpdated, productConfiguration } = this.props;
    return (
      <div className="col">
        <div className="card mb-3 box-shadow">
          <div className="order-tabs">
            <Nav pills className="justify-content-center">
              <NavItem>
                <NavLink
                  href="#"
                  className={
                    this.state.activeTab === 'Shipments' ? 'active' : null
                  }
                  onClick={() => {
                    this.toggle('Shipments');
                  }}
                >
                  Shipments
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={
                    this.state.activeTab === 'LineItems' ? 'active' : null
                  }
                  onClick={() => {
                    this.toggle('LineItems');
                  }}
                >
                  Products
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="Shipments">
              <OrderShipmentsContainer
                order={order}
                onShipmentsUpdated={onShipmentsUpdated}
                productConfiguration={productConfiguration}
              />
            </TabPane>
            <TabPane tabId="LineItems">
              <div className="order-shipments">
                <OrderLineItemsComponent
                  order={order}
                  productConfiguration={productConfiguration}
                  loadOrder={onShipmentsUpdated}
                />
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}
